import { Alert, AlertType, Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { inAppChatService } from '@egw/app-chat'

export const ApplicationUnderReview: FC = () => {
  const { t } = useTranslation('features-auth')

  const clientServicesOnClick = (): void => {
    inAppChatService.open()
  }

  return (
    <div className="egw-container flex flex-col gap-4 h-full">
      <h1 className="typo-primary-xl-light text-text-header md:mt-2xl">{t('application_under_review.title')}</h1>
      <Alert alertType={AlertType.Warning} className="w-fit" description={t('application_under_review.alert_warning')} />
      <p className="typo-primary-base-regular text-text-meta">{t('application_under_review.p1')}</p>
      <div className="flex grow md:hidden" />
      <Button onClick={clientServicesOnClick} className="w-full md:w-fit">
        {t('application_under_review.cta')}
      </Button>
    </div>
  )
}
